import { c as _c } from "react/compiler-runtime";
import { GroupDescriptionType } from "@/entities/IGroup";
import type { GroupCardConfigProps } from "./GroupCardConfigs";
export default function GroupCardConfig(t0) {
  const $ = _c(10);
  const {
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [GroupDescriptionType.TDH]: "Tdh",
      [GroupDescriptionType.REP]: "Rep",
      [GroupDescriptionType.NIC]: "NIC",
      [GroupDescriptionType.LEVEL]: "Level",
      [GroupDescriptionType.OWNS_NFTS]: "Owns NFTs",
      [GroupDescriptionType.WALLETS]: "Manual list",
      [GroupDescriptionType.XTDH_GRANT]: "Grant"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const configLabel = t1;
  const t2 = config.label ?? configLabel[config.key];
  let t3;
  if ($[1] !== t2) {
    t3 = <span className="tw-text-iron-400">{t2}:</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `tw-whitespace-nowrap ${config.muted ? "tw-text-iron-500" : "tw-font-semibold tw-text-iron-50"}`;
  let t5;
  if ($[3] !== config.value || $[4] !== t4) {
    t5 = <span className={t4}>{config.value}</span>;
    $[3] = config.value;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== config.tooltip || $[7] !== t3 || $[8] !== t5) {
    t6 = <div className="tw-inline-flex tw-cursor-default tw-items-center tw-gap-x-1 tw-text-xs tw-font-medium tw-text-iron-200 sm:tw-text-sm" title={config.tooltip}>{t3}{t5}</div>;
    $[6] = config.tooltip;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}